import React from 'react';
import { FormOptions, ConcreteForm } from './typed';

export interface FormContextProps {
  options?: FormOptions;
  form?: ConcreteForm;
  selectors?: {
    getDataByKey: (key: string) => any;
    getInitalValue: () => any;
  };
}

export const FormContext = React.createContext<FormContextProps>({});
